import React from 'react';
import ActionIconButton from './ActionIconButton';

const SearchButton = ({title = 'Buscar', ...props}) => (
    <ActionIconButton variant="search" title={title} {...props}/>
);

export default SearchButton;
